import { vec2 } from "gl-matrix";
import { useSyncExternalStore } from "react";

type PendingSectionPlaneCreateOrigin = {
    index: number;
    point: vec2;
} | null;

let pendingCreateOrigin: PendingSectionPlaneCreateOrigin = null;
const listeners = new Set<() => void>();

function emit() {
    listeners.forEach((listener) => listener());
}

export function showSectionPlaneMenuButtonAtPoint(index: number, point: vec2) {
    pendingCreateOrigin = {
        index,
        point: vec2.clone(point),
    };
    emit();
}

export function clearSectionPlaneCreateOrigin() {
    if (!pendingCreateOrigin) {
        return;
    }
    pendingCreateOrigin = null;
    emit();
}

export function useSectionPlaneCreateOrigin() {
    return useSyncExternalStore(
        (listener) => {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
        () => pendingCreateOrigin,
        () => pendingCreateOrigin,
    );
}

// Used in tests.
export function getSectionPlaneCreateOrigin() {
    return pendingCreateOrigin
        ? { index: pendingCreateOrigin.index, point: vec2.clone(pendingCreateOrigin.point) }
        : null;
}

// Used in tests.
export function resetSectionPlaneCreateOrigin() {
    pendingCreateOrigin = null;
    listeners.clear();
}
